import { get } from 'lodash';
import { enrich } from '../../helpers';

// To be consistent with selectors of other ducks and prepare for
// additional selectors:
// eslint-disable-next-line import/prefer-default-export
export function selectActivitylogForNode(slice, nodeId) {
  return get(slice, `activitylogs.${nodeId}`, enrich());
}
